// ─── Configs de tipo de actividad ───
export const activityTypeConfigs = [
  {
    id: 'comentario',
    label: 'Comentó',
    icon: 'ri-chat-3-line',
    color: 'sky',
    gradient: 'from-sky-400 to-sky-500',
    verb: 'comentó en',
  },
  {
    id: 'subida',
    label: 'Subió contenido',
    icon: 'ri-upload-cloud-2-line',
    color: 'emerald',
    gradient: 'from-emerald-400 to-emerald-500',
    verb: 'subió',
  },
  {
    id: 'nuevo_concurso',
    label: 'Nuevo Concurso',
    icon: 'ri-trophy-line',
    color: 'amber',
    gradient: 'from-amber-400 to-amber-500',
    verb: 'lanzó',
  },
  {
    id: 'nuevo_ganador',
    label: 'Nuevo Ganador',
    icon: 'ri-medal-line',
    color: 'rose',
    gradient: 'from-rose-400 to-rose-500',
    verb: 'ganó',
  },
  {
    id: 'nuevo_evento',
    label: 'Nuevo Evento',
    icon: 'ri-calendar-event-line',
    color: 'violet',
    gradient: 'from-violet-400 to-violet-500',
    verb: 'creó',
  },
  {
    id: 'nueva_radio',
    label: 'Nueva Radio',
    icon: 'ri-radio-line',
    color: 'orange',
    gradient: 'from-orange-400 to-orange-500',
    verb: 'se unió a RFW',
  },
  {
    id: 'nuevo_club',
    label: 'Nuevo Club',
    icon: 'ri-group-line',
    color: 'fuchsia',
    gradient: 'from-fuchsia-400 to-fuchsia-500',
    verb: 'fundó',
  },
];

// ─── Configs de filtro ───
export const filterConfigs = [
  { id: 'todo', label: 'Todo', icon: 'ri-global-line', color: 'foreground' },
  { id: 'radios', label: 'Radios', icon: 'ri-radio-line', color: 'orange' },
  { id: 'programas', label: 'Programas', icon: 'ri-calendar-check-line', color: 'violet' },
  { id: 'locutores', label: 'Locutores', icon: 'ri-mic-line', color: 'sky' },
  { id: 'clubes', label: 'Clubes', icon: 'ri-group-line', color: 'fuchsia' },
  { id: 'eventos', label: 'Eventos', icon: 'ri-calendar-event-line', color: 'amber' },
];

// ─── Entradas de actividad global ───
export const globalActivityEntries = [
  {
    id: 'act-001',
    type: 'comentario',
    filterId: 'locutores',
    timestamp: '2026-06-21T14:32:00Z',
    user: { name: 'Juan Carlos Méndez', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20man%20portrait%20with%20warm%20smile%2C%20clean%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%20style%2C%20sharp%20detail%2C%20natural%20expression&width=120&height=120&seq=global-avatar-01&orientation=squarish' },
    target: { name: 'El Monstruo Ramírez', type: 'Locutor', link: '/host/el-monstruo-ramirez' },
    excerpt: '¡Qué programa increíble hoy! El Monstruo está en su mejor momento. La entrevista con Carlos Vives estuvo brutal.',
    commentsCount: 24,
    reactionsCount: 156,
  },
  {
    id: 'act-002',
    type: 'subida',
    filterId: 'radios',
    timestamp: '2026-06-21T14:15:00Z',
    user: { name: 'La Mega', avatar: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20design%2C%20bold%20geometric%20shapes%2C%20vibrant%20warm%20colors%2C%20clean%20minimal%20background%2C%20professional%20broadcasting%20brand%20identity&width=120&height=120&seq=global-avatar-02&orientation=squarish' },
    target: { name: 'Playlist Oficial: Éxitos del Verano 2026', type: 'Playlist', link: '/radio/la-mega' },
    excerpt: 'La Mega actualizó su playlist oficial con los 50 éxitos que están sonando este verano. ¡Imperdible!',
    commentsCount: 18,
    reactionsCount: 342,
  },
  {
    id: 'act-003',
    type: 'nuevo_concurso',
    filterId: 'radios',
    timestamp: '2026-06-21T13:50:00Z',
    user: { name: 'Radio Nacional', avatar: 'https://readdy.ai/api/search-image?query=Classic%20elegant%20radio%20station%20emblem%2C%20gold%20and%20navy%20color%20scheme%2C%20traditional%20broadcasting%20design%2C%20clean%20white%20background%2C%20professional%20heritage%20brand&width=120&height=120&seq=global-avatar-03&orientation=squarish' },
    target: { name: 'Concurso: La Voz Colombia 2026', type: 'Concurso', link: '/competencias' },
    excerpt: 'Radio Nacional lanza La Voz Colombia 2026 con un premio de ₡5,000,000 y contrato de grabación. Inscripciones abiertas.',
    commentsCount: 89,
    reactionsCount: 1204,
  },
  {
    id: 'act-004',
    type: 'nuevo_ganador',
    filterId: 'locutores',
    timestamp: '2026-06-21T13:30:00Z',
    user: { name: 'María José', avatar: 'https://readdy.ai/api/search-image?query=Warm%20Hispanic%20woman%20portrait%20with%20genuine%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20photography%2C%20friendly%20authentic%20expression&width=120&height=120&seq=global-avatar-04&orientation=squarish' },
    target: { name: 'Trivia Musical Mensual', type: 'Trivia', link: '/trivias' },
    excerpt: 'María José ganó la Trivia Musical Mensual de Junio con 9 de 10 respuestas correctas en solo 47 segundos. ¡Nuevo récord!',
    commentsCount: 45,
    reactionsCount: 678,
  },
  {
    id: 'act-005',
    type: 'nuevo_evento',
    filterId: 'eventos',
    timestamp: '2026-06-21T13:00:00Z',
    user: { name: 'Carrusel Deportivo', avatar: 'https://readdy.ai/api/search-image?query=Sports%20radio%20program%20logo%2C%20dynamic%20design%20with%20soccer%20ball%20motif%2C%20energetic%20red%20and%20green%20colors%2C%20clean%20white%20background%2C%20modern%20sports%20brand&width=120&height=120&seq=global-avatar-05&orientation=squarish' },
    target: { name: 'Final Copa América 2026: Transmisión en Vivo', type: 'Evento', link: '/eventos' },
    excerpt: 'Carrusel Deportivo anuncia transmisión especial en vivo de la Final Copa América 2026 desde el estadio. Cobertura total.',
    commentsCount: 234,
    reactionsCount: 3401,
  },
  {
    id: 'act-006',
    type: 'nueva_radio',
    filterId: 'radios',
    timestamp: '2026-06-21T12:45:00Z',
    user: { name: 'Radio Vallenata FM', avatar: 'https://readdy.ai/api/search-image?query=Folk%20music%20radio%20station%20logo%2C%20warm%20earth%20tones%2C%20accordion%20silhouette%2C%20traditional%20Colombian%20branding%2C%20clean%20cream%20background%2C%20cultural%20identity&width=120&height=120&seq=global-avatar-06&orientation=squarish' },
    target: { name: 'Radio Vallenata FM 98.3', type: 'Radio', link: '/radio/radio-vallenata-fm' },
    excerpt: '¡Bienvenida Radio Vallenata FM 98.3 a la familia RFW! La nueva emisora de música vallenata y folclor colombiano.',
    commentsCount: 56,
    reactionsCount: 892,
  },
  {
    id: 'act-007',
    type: 'nuevo_club',
    filterId: 'clubes',
    timestamp: '2026-06-21T12:30:00Z',
    user: { name: 'Los Melómanos', avatar: 'https://readdy.ai/api/search-image?query=Music%20enthusiast%20club%20logo%2C%20vinyl%20record%20design%20element%2C%20warm%20retro%20colors%2C%20clean%20minimal%20background%2C%20community%20brand%20identity&width=120&height=120&seq=global-avatar-07&orientation=squarish' },
    target: { name: 'Club Los Melómanos', type: 'Club', link: '/clubes' },
    excerpt: 'Los Melómanos fundan su club oficial en RFW: un espacio para amantes de la música con sesiones de escucha, debates y playlists curadas.',
    commentsCount: 12,
    reactionsCount: 234,
  },
  {
    id: 'act-008',
    type: 'comentario',
    filterId: 'programas',
    timestamp: '2026-06-21T12:15:00Z',
    user: { name: 'Carolina Torres', avatar: 'https://readdy.ai/api/search-image?query=Confident%20Hispanic%20woman%20portrait%2C%20modern%20professional%20look%2C%20soft%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20warm%20expression&width=120&height=120&seq=global-avatar-08&orientation=squarish' },
    target: { name: 'Despierta Con Energía', type: 'Programa', link: '/program/despierta-con-energia' },
    excerpt: 'El segmento de salud mental de hoy fue necesario. Gracias por hablar de estos temas con tanta sensibilidad y profesionalismo.',
    commentsCount: 31,
    reactionsCount: 445,
  },
  {
    id: 'act-009',
    type: 'subida',
    filterId: 'locutores',
    timestamp: '2026-06-21T11:50:00Z',
    user: { name: 'Andrea Valencia', avatar: 'https://readdy.ai/api/search-image?query=Charismatic%20Latina%20radio%20host%20portrait%2C%20warm%20energetic%20smile%2C%20professional%20studio%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20headshot%2C%20confident%20presence&width=120&height=120&seq=global-avatar-09&orientation=squarish' },
    target: { name: 'Entrevista Exclusiva: Shakira', type: 'Video', link: '/host/andrea-valencia' },
    excerpt: 'Andrea Valencia subió la entrevista exclusiva con Shakira hablando de su nuevo álbum. ¡35 minutos de pura magia!',
    commentsCount: 167,
    reactionsCount: 2890,
  },
  {
    id: 'act-010',
    type: 'nuevo_concurso',
    filterId: 'programas',
    timestamp: '2026-06-21T11:30:00Z',
    user: { name: 'El Despertador', avatar: 'https://readdy.ai/api/search-image?query=Morning%20radio%20show%20logo%2C%20bright%20sunrise%20colors%2C%20energetic%20design%2C%20coffee%20cup%20motif%2C%20clean%20white%20background%2C%20modern%20morning%20show%20brand&width=120&height=120&seq=global-avatar-10&orientation=squarish' },
    target: { name: 'Desafío de los 30 Días', type: 'Concurso', link: '/competencias' },
    excerpt: 'El Despertador lanza el Desafío de los 30 Días: participa todos los días y gana un viaje todo pagado a Cartagena.',
    commentsCount: 203,
    reactionsCount: 1567,
  },
  {
    id: 'act-011',
    type: 'nuevo_ganador',
    filterId: 'radios',
    timestamp: '2026-06-21T11:00:00Z',
    user: { name: 'Pedro Gutiérrez', avatar: 'https://readdy.ai/api/search-image?query=Happy%20Hispanic%20man%20celebrating%2C%20excited%20expression%2C%20bright%20studio%20lighting%2C%20neutral%20white%20background%2C%20editorial%20portrait%2C%20joyful%20victory%20pose&width=120&height=120&seq=global-avatar-11&orientation=squarish' },
    target: { name: 'Concurso de Talentos Beat 106', type: 'Concurso', link: '/ganadores' },
    excerpt: 'Pedro Gutiérrez ganó el Concurso de Talentos de Beat 106 con su cover de guitarra flamenca. ¡Contrato de presentación en vivo!',
    commentsCount: 78,
    reactionsCount: 1234,
  },
  {
    id: 'act-012',
    type: 'nuevo_evento',
    filterId: 'clubes',
    timestamp: '2026-06-21T10:40:00Z',
    user: { name: 'Club Retro Hits', avatar: 'https://readdy.ai/api/search-image?query=Retro%20music%20club%20logo%2C%20vintage%20cassette%20tape%20design%2C%20neon%20colors%2C%20clean%20dark%20background%2C%2080s%20aesthetic%2C%20nostalgic%20community%20brand&width=120&height=120&seq=global-avatar-12&orientation=squarish' },
    target: { name: 'Noche de Vinilos: 80s Edition', type: 'Evento', link: '/eventos' },
    excerpt: 'Club Retro Hits organiza Noche de Vinilos 80s Edition: sesión de escucha con vinilos originales, debate y trivia retro.',
    commentsCount: 34,
    reactionsCount: 567,
  },
  {
    id: 'act-013',
    type: 'comentario',
    filterId: 'eventos',
    timestamp: '2026-06-21T10:15:00Z',
    user: { name: 'Diego Ramírez', avatar: 'https://readdy.ai/api/search-image?query=Young%20Hispanic%20man%20portrait%2C%20stylish%20casual%20look%2C%20soft%20natural%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20friendly%20smile&width=120&height=120&seq=global-avatar-13&orientation=squarish' },
    target: { name: 'Festival RFW 2026', type: 'Evento', link: '/eventos' },
    excerpt: '¡Ya compré mis entradas para el Festival RFW 2026! La alineación de este año está brutal. ¿Quién más va?',
    commentsCount: 89,
    reactionsCount: 678,
  },
  {
    id: 'act-014',
    type: 'subida',
    filterId: 'programas',
    timestamp: '2026-06-21T09:50:00Z',
    user: { name: 'Tropicana', avatar: 'https://readdy.ai/api/search-image?query=Vibrant%20tropical%20radio%20station%20logo%2C%20palm%20tree%20silhouette%2C%20energetic%20yellow%20and%20green%20colors%2C%20clean%20white%20background%2C%20caribbean%20vibe%20brand&width=120&height=120&seq=global-avatar-14&orientation=squarish' },
    target: { name: 'Podcast: Secretos de la Salsa', type: 'Podcast', link: '/program/secretos-de-la-salsa' },
    excerpt: 'Tropicana estrenó el podcast "Secretos de la Salsa": 10 episodios con las historias detrás de los clásicos de la salsa.',
    commentsCount: 45,
    reactionsCount: 890,
  },
  {
    id: 'act-015',
    type: 'nueva_radio',
    filterId: 'radios',
    timestamp: '2026-06-21T09:30:00Z',
    user: { name: 'Jazz Café Radio', avatar: 'https://readdy.ai/api/search-image?query=Sophisticated%20jazz%20radio%20station%20logo%2C%20saxophone%20and%20coffee%20cup%20design%2C%20warm%20brown%20and%20gold%20tones%2C%20clean%20cream%20background%2C%20elegant%20cultural%20brand&width=120&height=120&seq=global-avatar-15&orientation=squarish' },
    target: { name: 'Jazz Café Radio 102.7', type: 'Radio', link: '/radio/jazz-cafe-radio' },
    excerpt: 'Jazz Café Radio 102.7 llega a RFW: 24 horas de jazz, bossa nova y música instrumental. El rincón perfecto para los amantes del jazz.',
    commentsCount: 23,
    reactionsCount: 345,
  },
  {
    id: 'act-016',
    type: 'comentario',
    filterId: 'radios',
    timestamp: '2026-06-21T09:00:00Z',
    user: { name: 'Laura Martínez', avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Hispanic%20woman%20portrait%2C%20professional%20attire%2C%20soft%20window%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20headshot%2C%20confident%20gaze&width=120&height=120&seq=global-avatar-16&orientation=squarish' },
    target: { name: 'Radio Nacional', type: 'Radio', link: '/radio/radio-nacional' },
    excerpt: 'Radio Nacional es mi compañía diaria. La programación cultural es de primer nivel. Gracias por mantener viva la radio pública.',
    commentsCount: 41,
    reactionsCount: 567,
  },
  {
    id: 'act-017',
    type: 'nuevo_ganador',
    filterId: 'programas',
    timestamp: '2026-06-21T08:45:00Z',
    user: { name: 'Los Viajeros del Ritmo', avatar: 'https://readdy.ai/api/search-image?query=Music%20band%20group%20photo%2C%20four%20Hispanic%20musicians%20with%20instruments%2C%20dynamic%20pose%2C%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20photography&width=120&height=120&seq=global-avatar-17&orientation=squarish' },
    target: { name: 'Batalla de Bandas RFW', type: 'Competencia', link: '/competencias' },
    excerpt: 'Los Viajeros del Ritmo ganaron la Batalla de Bandas RFW con 12,450 votos. ¡Debutarán en vivo en el Festival RFW 2026!',
    commentsCount: 156,
    reactionsCount: 2345,
  },
  {
    id: 'act-018',
    type: 'nuevo_club',
    filterId: 'clubes',
    timestamp: '2026-06-21T08:30:00Z',
    user: { name: 'Fitness Lovers', avatar: 'https://readdy.ai/api/search-image?query=Fitness%20community%20logo%2C%20dumbbell%20and%20music%20note%20design%2C%20energetic%20orange%20and%20teal%20colors%2C%20clean%20white%20background%2C%20active%20lifestyle%20brand&width=120&height=120&seq=global-avatar-18&orientation=squarish' },
    target: { name: 'Club Fitness Lovers', type: 'Club', link: '/clubes' },
    excerpt: 'Fitness Lovers abre su club en RFW: playlists para entrenar, retos de ejercicio semanales y comunidad motivadora.',
    commentsCount: 67,
    reactionsCount: 789,
  },
  {
    id: 'act-019',
    type: 'comentario',
    filterId: 'clubes',
    timestamp: '2026-06-21T08:15:00Z',
    user: { name: 'Sofía Herrera', avatar: 'https://readdy.ai/api/search-image?query=Young%20Hispanic%20woman%20portrait%20with%20headphones%2C%20casual%20stylish%20look%2C%20natural%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20headshot%2C%20music%20lover%20vibe&width=120&height=120&seq=global-avatar-19&orientation=squarish' },
    target: { name: 'Club de Fans de Shakira', type: 'Club', link: '/clubes' },
    excerpt: 'El Club de Fans de Shakira ya tiene 500 miembros en solo una semana. ¡La comunidad crece rapidísimo!',
    commentsCount: 89,
    reactionsCount: 1234,
  },
  {
    id: 'act-020',
    type: 'subida',
    filterId: 'radios',
    timestamp: '2026-06-21T07:50:00Z',
    user: { name: 'Beat 106', avatar: 'https://readdy.ai/api/search-image?query=Urban%20music%20radio%20station%20logo%2C%20bold%20graffiti%20style%20design%2C%20electric%20colors%2C%20clean%20white%20background%2C%20contemporary%20youth%20brand&width=120&height=120&seq=global-avatar-20&orientation=squarish' },
    target: { name: 'Sesión en Vivo: Feid', type: 'Video', link: '/radio/beat-106' },
    excerpt: 'Beat 106 subió la sesión en vivo exclusiva de Feid desde los estudios: 4 canciones en formato acústico. ¡Imperdible!',
    commentsCount: 234,
    reactionsCount: 4567,
  },
  {
    id: 'act-021',
    type: 'nuevo_evento',
    filterId: 'radios',
    timestamp: '2026-06-20T22:30:00Z',
    user: { name: 'Olímpica Stereo', avatar: 'https://readdy.ai/api/search-image?query=Caribbean%20radio%20station%20logo%2C%20tropical%20sunset%20design%2C%20vibrant%20warm%20colors%2C%20clean%20white%20background%2C%20festive%20broadcasting%20brand&width=120&height=120&seq=global-avatar-21&orientation=squarish' },
    target: { name: 'Fiesta de Verano Olímpica 2026', type: 'Evento', link: '/eventos' },
    excerpt: 'Olímpica Stereo anuncia su Fiesta de Verano 2026 en la playa con artistas sorpresa, concursos y transmisión en vivo.',
    commentsCount: 178,
    reactionsCount: 2890,
  },
  {
    id: 'act-022',
    type: 'nuevo_concurso',
    filterId: 'locutores',
    timestamp: '2026-06-20T21:00:00Z',
    user: { name: 'El Monstruo Ramírez', avatar: 'https://readdy.ai/api/search-image?query=Charismatic%20male%20radio%20host%2C%20dynamic%20personality%2C%20bold%20expression%2C%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20energetic%20presence&width=120&height=120&seq=global-avatar-22&orientation=squarish' },
    target: { name: 'El Reto del Monstruo', type: 'Concurso', link: '/competencias' },
    excerpt: 'El Monstruo Ramírez lanza "El Reto del Monstruo": concurso de imitación de locutores con premios semanales.',
    commentsCount: 134,
    reactionsCount: 2100,
  },
  {
    id: 'act-023',
    type: 'nuevo_ganador',
    filterId: 'clubes',
    timestamp: '2026-06-20T20:15:00Z',
    user: { name: 'Ana María López', avatar: 'https://readdy.ai/api/search-image?query=Happy%20Hispanic%20woman%20holding%20award%2C%20proud%20expression%2C%20soft%20studio%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20portrait%2C%20celebratory%20mood&width=120&height=120&seq=global-avatar-23&orientation=squarish' },
    target: { name: 'Trivia Retro del Club 80s', type: 'Trivia', link: '/trivias' },
    excerpt: 'Ana María López es la campeona de la Trivia Retro del Club 80s con puntuación perfecta. ¡10 de 10 en solo 38 segundos!',
    commentsCount: 45,
    reactionsCount: 567,
  },
  {
    id: 'act-024',
    type: 'comentario',
    filterId: 'programas',
    timestamp: '2026-06-20T19:30:00Z',
    user: { name: 'Roberto Sánchez', avatar: 'https://readdy.ai/api/search-image?query=Mature%20Hispanic%20man%20portrait%2C%20warm%20fatherly%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20approachable%20demeanor&width=120&height=120&seq=global-avatar-24&orientation=squarish' },
    target: { name: 'Historias del Fútbol', type: 'Programa', link: '/program/historias-del-futbol' },
    excerpt: 'El episodio de hoy sobre la historia del fútbol colombiano en los 90s fue espectacular. Reviví mi infancia. Gracias.',
    commentsCount: 34,
    reactionsCount: 456,
  },
  {
    id: 'act-025',
    type: 'subida',
    filterId: 'locutores',
    timestamp: '2026-06-20T18:45:00Z',
    user: { name: 'Carlos Ponce', avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20radio%20host%20with%20headset%2C%20focused%20expression%2C%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20broadcasting%20professional&width=120&height=120&seq=global-avatar-25&orientation=squarish' },
    target: { name: 'Especial: Historia del Rock en Español', type: 'Podcast', link: '/host/carlos-ponce' },
    excerpt: 'Carlos Ponce estrenó el especial "Historia del Rock en Español": 8 episodios desde Soda Stereo hasta los nuevos exponentes.',
    commentsCount: 89,
    reactionsCount: 1678,
  },
  {
    id: 'act-026',
    type: 'nuevo_club',
    filterId: 'clubes',
    timestamp: '2026-06-20T18:00:00Z',
    user: { name: 'Foodies RFW', avatar: 'https://readdy.ai/api/search-image?query=Food%20community%20logo%20with%20fork%20and%20spoon%2C%20warm%20appetizing%20colors%2C%20clean%20cream%20background%2C%20culinary%20community%20brand%2C%20modern%20foodie%20design&width=120&height=120&seq=global-avatar-26&orientation=squarish' },
    target: { name: 'Club Foodies RFW', type: 'Club', link: '/clubes' },
    excerpt: 'Foodies RFW abre su club: recetas, recomendaciones de restaurantes, maridajes musicales y eventos gastronómicos.',
    commentsCount: 56,
    reactionsCount: 789,
  },
  {
    id: 'act-027',
    type: 'nueva_radio',
    filterId: 'radios',
    timestamp: '2026-06-20T17:15:00Z',
    user: { name: 'Radio Indie', avatar: 'https://readdy.ai/api/search-image?query=Indie%20music%20radio%20logo%2C%20minimalist%20geometric%20design%2C%20muted%20warm%20tones%2C%20clean%20white%20background%2C%20alternative%20culture%20brand&width=120&height=120&seq=global-avatar-27&orientation=squarish' },
    target: { name: 'Radio Indie 95.1', type: 'Radio', link: '/radio/radio-indie' },
    excerpt: 'Radio Indie 95.1 se une a RFW: música independiente, bandas emergentes y lo mejor del under nacional e internacional.',
    commentsCount: 34,
    reactionsCount: 456,
  },
  {
    id: 'act-028',
    type: 'comentario',
    filterId: 'locutores',
    timestamp: '2026-06-20T16:30:00Z',
    user: { name: 'Valentina Ruiz', avatar: 'https://readdy.ai/api/search-image?query=Stylish%20Hispanic%20woman%20portrait%2C%20modern%20fashion%20look%2C%20studio%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20headshot%2C%20trendy%20vibe&width=120&height=120&seq=global-avatar-28&orientation=squarish' },
    target: { name: 'Andrea Valencia', type: 'Locutor', link: '/host/andrea-valencia' },
    excerpt: 'Andrea Valencia es la mejor entrevistadora de radio colombiana. Su entrevista con Karol G fue histórica. ¡Ícono total!',
    commentsCount: 123,
    reactionsCount: 2345,
  },
  {
    id: 'act-029',
    type: 'nuevo_ganador',
    filterId: 'radios',
    timestamp: '2026-06-20T15:45:00Z',
    user: { name: 'Miguel Ángel Castro', avatar: 'https://readdy.ai/api/search-image?query=Proud%20Hispanic%20man%20with%20trophy%2C%20achievement%20celebration%2C%20studio%20lighting%2C%20neutral%20white%20background%2C%20editorial%20portrait%2C%20victory%20expression&width=120&height=120&seq=global-avatar-29&orientation=squarish' },
    target: { name: 'Concurso de Doblaje La Mega', type: 'Concurso', link: '/ganadores' },
    excerpt: 'Miguel Ángel Castro ganó el Concurso de Doblaje de La Mega con su imitación perfecta de 10 locutores en 60 segundos.',
    commentsCount: 67,
    reactionsCount: 890,
  },
  {
    id: 'act-030',
    type: 'subida',
    filterId: 'programas',
    timestamp: '2026-06-20T15:00:00Z',
    user: { name: 'El Top 40', avatar: 'https://readdy.ai/api/search-image?query=Music%20chart%20show%20logo%2C%20countdown%20design%2C%20bold%20numbers%2C%20energetic%20colors%2C%20clean%20white%20background%2C%20modern%20chart%20brand&width=120&height=120&seq=global-avatar-30&orientation=squarish' },
    target: { name: 'Top 40: Los Más Pedidos', type: 'Lista', link: '/program/el-top-40' },
    excerpt: 'El Top 40 publicó la lista de Los Más Pedidos de la semana. Feid, Shakira y Karol G dominan los primeros puestos.',
    commentsCount: 56,
    reactionsCount: 1234,
  },
  {
    id: 'act-031',
    type: 'nuevo_concurso',
    filterId: 'eventos',
    timestamp: '2026-06-20T14:30:00Z',
    user: { name: 'Festival RFW', avatar: 'https://readdy.ai/api/search-image?query=Festival%20event%20logo%2C%20dynamic%20stage%20design%2C%20vibrant%20festive%20colors%2C%20clean%20dark%20background%2C%20modern%20music%20festival%20brand&width=120&height=120&seq=global-avatar-31&orientation=squarish' },
    target: { name: 'Concurso Meet & Greet Festival RFW', type: 'Concurso', link: '/competencias' },
    excerpt: 'Festival RFW lanza concurso: gana Meet & Greet con los artistas principales. Solo necesitas compartir tu canción favorita.',
    commentsCount: 345,
    reactionsCount: 4567,
  },
  {
    id: 'act-032',
    type: 'comentario',
    filterId: 'radios',
    timestamp: '2026-06-20T14:00:00Z',
    user: { name: 'Gabriel Torres', avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Hispanic%20man%20portrait%2C%20casual%20smile%2C%20natural%20outdoor%20lighting%2C%20neutral%20blurred%20background%2C%20editorial%20headshot%2C%20approachable%20vibe&width=120&height=120&seq=global-avatar-32&orientation=squarish' },
    target: { name: 'Radio Tiempo', type: 'Radio', link: '/radio/radio-tiempo' },
    excerpt: 'Radio Tiempo tiene la mejor selección musical de la ciudad. Llevo 5 años escuchándolos y nunca me decepcionan.',
    commentsCount: 23,
    reactionsCount: 345,
  },
  {
    id: 'act-033',
    type: 'nueva_radio',
    filterId: 'radios',
    timestamp: '2026-06-20T13:30:00Z',
    user: { name: 'Éxitos FM', avatar: 'https://readdy.ai/api/search-image?query=Hit%20music%20radio%20station%20logo%2C%20star%20design%20element%2C%20bright%20gold%20and%20red%20colors%2C%20clean%20white%20background%2C%20top%2040%20brand%20identity&width=120&height=120&seq=global-avatar-33&orientation=squarish' },
    target: { name: 'Éxitos FM 91.7', type: 'Radio', link: '/radio/exitos-fm' },
    excerpt: 'Éxitos FM 91.7 llega a RFW: los mejores hits de ayer y hoy, 24 horas de música sin parar.',
    commentsCount: 45,
    reactionsCount: 678,
  },
  {
    id: 'act-034',
    type: 'nuevo_evento',
    filterId: 'programas',
    timestamp: '2026-06-20T12:45:00Z',
    user: { name: 'Salsa Y Más', avatar: 'https://readdy.ai/api/search-image?query=Salsa%20music%20radio%20program%20logo%2C%20trumpet%20and%20dance%20design%2C%20vibrant%20red%20and%20black%20colors%2C%20clean%20white%20background%2C%20Latin%20music%20brand&width=120&height=120&seq=global-avatar-34&orientation=squarish' },
    target: { name: 'Noche de Salsa en Vivo', type: 'Evento', link: '/eventos' },
    excerpt: 'Salsa Y Más organiza Noche de Salsa en Vivo con orquesta en el estudio. Transmisión especial este sábado.',
    commentsCount: 89,
    reactionsCount: 1567,
  },
  {
    id: 'act-035',
    type: 'nuevo_ganador',
    filterId: 'eventos',
    timestamp: '2026-06-20T12:00:00Z',
    user: { name: 'Diana Carolina', avatar: 'https://readdy.ai/api/search-image?query=Radiant%20Hispanic%20woman%20with%20crown%2C%20beauty%20pageant%20winner%20vibe%2C%20studio%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20portrait%2C%20elegant%20presence&width=120&height=120&seq=global-avatar-35&orientation=squarish' },
    target: { name: 'Reina del Verano RFW', type: 'Competencia', link: '/ganadores' },
    excerpt: 'Diana Carolina fue coronada Reina del Verano RFW 2026 con 15,890 votos. Representará a RFW en eventos nacionales.',
    commentsCount: 234,
    reactionsCount: 3456,
  },
  {
    id: 'act-036',
    type: 'comentario',
    filterId: 'eventos',
    timestamp: '2026-06-20T11:15:00Z',
    user: { name: 'Jorge Ochoa', avatar: 'https://readdy.ai/api/search-image?query=Enthusiastic%20Hispanic%20man%20portrait%2C%20passionate%20expression%2C%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20excited%20music%20fan&width=120&height=120&seq=global-avatar-36&orientation=squarish' },
    target: { name: 'Concierto Virtual: Grupo Niche', type: 'Evento', link: '/eventos' },
    excerpt: 'El concierto virtual de Grupo Niche fue una experiencia espectacular. La calidad de transmisión en RFW es increíble.',
    commentsCount: 45,
    reactionsCount: 890,
  },
  {
    id: 'act-037',
    type: 'subida',
    filterId: 'clubes',
    timestamp: '2026-06-20T10:30:00Z',
    user: { name: 'Club del Rock', avatar: 'https://readdy.ai/api/search-image?query=Rock%20music%20club%20logo%2C%20electric%20guitar%20design%2C%20dark%20and%20fiery%20colors%2C%20clean%20black%20background%2C%20rock%20community%20brand%2C%20rebellious%20aesthetic&width=120&height=120&seq=global-avatar-37&orientation=squarish' },
    target: { name: 'Jam Session Virtual: Clásicos del Rock', type: 'Evento Club', link: '/clubes' },
    excerpt: 'El Club del Rock organiza Jam Session Virtual de Clásicos del Rock este viernes. Trae tu instrumento y únete.',
    commentsCount: 67,
    reactionsCount: 890,
  },
  {
    id: 'act-038',
    type: 'nuevo_concurso',
    filterId: 'clubes',
    timestamp: '2026-06-20T09:45:00Z',
    user: { name: 'Club de Poesía', avatar: 'https://readdy.ai/api/search-image?query=Poetry%20club%20logo%2C%20feather%20pen%20design%2C%20elegant%20minimalist%20black%20and%20gold%2C%20clean%20cream%20background%2C%20literary%20community%20brand&width=120&height=120&seq=global-avatar-38&orientation=squarish' },
    target: { name: 'Concurso de Poesía Sonora', type: 'Concurso', link: '/competencias' },
    excerpt: 'El Club de Poesía lanza Concurso de Poesía Sonora: graba tu poema en audio y compite por publicación en antología digital.',
    commentsCount: 34,
    reactionsCount: 456,
  },
  {
    id: 'act-039',
    type: 'comentario',
    filterId: 'clubes',
    timestamp: '2026-06-20T09:00:00Z',
    user: { name: 'Natalia Gómez', avatar: 'https://readdy.ai/api/search-image?query=Creative%20Hispanic%20woman%20portrait%2C%20artistic%20look%2C%20soft%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20thoughtful%20expression&width=120&height=120&seq=global-avatar-39&orientation=squarish' },
    target: { name: 'Club de Cine y Música', type: 'Club', link: '/clubes' },
    excerpt: 'El análisis de bandas sonoras de hoy en el Club de Cine fue fascinante. La conexión entre Ennio Morricone y el western.',
    commentsCount: 23,
    reactionsCount: 345,
  },
  {
    id: 'act-040',
    type: 'nueva_radio',
    filterId: 'radios',
    timestamp: '2026-06-19T18:00:00Z',
    user: { name: 'Radio Paz', avatar: 'https://readdy.ai/api/search-image?query=Peaceful%20radio%20station%20logo%2C%20dove%20and%20music%20note%20design%2C%20calm%20blue%20and%20white%20colors%2C%20clean%20cream%20background%2C%20spiritual%20brand%20identity&width=120&height=120&seq=global-avatar-40&orientation=squarish' },
    target: { name: 'Radio Paz 88.5', type: 'Radio', link: '/radio/radio-paz' },
    excerpt: 'Radio Paz 88.5 se une a RFW: música inspiradora, reflexiones diarias y un espacio para la paz interior.',
    commentsCount: 78,
    reactionsCount: 1234,
  },
  {
    id: 'act-041',
    type: 'nuevo_club',
    filterId: 'clubes',
    timestamp: '2026-06-19T16:30:00Z',
    user: { name: 'Gamers RFW', avatar: 'https://readdy.ai/api/search-image?query=Gaming%20community%20logo%2C%20controller%20design%2C%20neon%20purple%20and%20cyan%20colors%2C%20clean%20dark%20background%2C%20esports%20community%20brand&width=120&height=120&seq=global-avatar-41&orientation=squarish' },
    target: { name: 'Club Gamers RFW', type: 'Club', link: '/clubes' },
    excerpt: 'Gamers RFW abre su club: torneos, playlists para jugar, streams de gameplay y comunidad gamer hispanohablante.',
    commentsCount: 112,
    reactionsCount: 1890,
  },
  {
    id: 'act-042',
    type: 'nuevo_ganador',
    filterId: 'programas',
    timestamp: '2026-06-19T15:00:00Z',
    user: { name: 'Los Cronistas', avatar: 'https://readdy.ai/api/search-image?query=Podcast%20show%20logo%2C%20microphone%20and%20notebook%20design%2C%20professional%20warm%20colors%2C%20clean%20white%20background%2C%20journalism%20brand&width=120&height=120&seq=global-avatar-42&orientation=squarish' },
    target: { name: 'Premio al Mejor Podcast RFW', type: 'Competencia', link: '/ganadores' },
    excerpt: 'Los Cronistas ganaron el Premio al Mejor Podcast RFW por su serie documental "Voces de Nuestra Tierra".',
    commentsCount: 89,
    reactionsCount: 1456,
  },
  {
    id: 'act-043',
    type: 'subida',
    filterId: 'radios',
    timestamp: '2026-06-19T14:00:00Z',
    user: { name: 'Radio Nacional', avatar: 'https://readdy.ai/api/search-image?query=Classic%20elegant%20radio%20station%20emblem%2C%20gold%20and%20navy%20color%20scheme%2C%20traditional%20broadcasting%20design%2C%20clean%20white%20background%2C%20professional%20heritage%20brand&width=120&height=120&seq=global-avatar-03&orientation=squarish' },
    target: { name: 'Archivo Histórico: Grandes Discursos', type: 'Colección', link: '/radio/radio-nacional' },
    excerpt: 'Radio Nacional digitalizó su archivo histórico: 50 grandes discursos que marcaron la historia de Colombia. Joya patrimonial.',
    commentsCount: 156,
    reactionsCount: 2345,
  },
  {
    id: 'act-044',
    type: 'comentario',
    filterId: 'programas',
    timestamp: '2026-06-19T12:30:00Z',
    user: { name: 'Fernanda Castillo', avatar: 'https://readdy.ai/api/search-image?query=Warm%20Hispanic%20woman%20portrait%2C%20kind%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20cream%20background%2C%20editorial%20headshot%2C%20friendly%20approachable%20vibe&width=120&height=120&seq=global-avatar-44&orientation=squarish' },
    target: { name: 'Mujeres Al Aire', type: 'Programa', link: '/program/mujeres-al-aire' },
    excerpt: 'El episodio de hoy de Mujeres Al Aire sobre liderazgo femenino en medios fue inspirador. Necesitamos más programas así.',
    commentsCount: 67,
    reactionsCount: 890,
  },
  {
    id: 'act-045',
    type: 'nuevo_evento',
    filterId: 'locutores',
    timestamp: '2026-06-19T11:00:00Z',
    user: { name: 'Marcela Jiménez', avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%2C%20authoritative%20yet%20warm%20presence%2C%20studio%20lighting%2C%20neutral%20gray%20background%2C%20editorial%20headshot%2C%20broadcasting%20professional&width=120&height=120&seq=global-avatar-45&orientation=squarish' },
    target: { name: 'Taller: Cómo Iniciar tu Podcast', type: 'Evento', link: '/eventos' },
    excerpt: 'Marcela Jiménez organiza taller gratuito "Cómo Iniciar tu Podcast": equipo, grabación, edición y distribución.',
    commentsCount: 145,
    reactionsCount: 2345,
  },
  {
    id: 'act-046',
    type: 'nuevo_concurso',
    filterId: 'radios',
    timestamp: '2026-06-19T09:30:00Z',
    user: { name: 'Tropicana', avatar: 'https://readdy.ai/api/search-image?query=Vibrant%20tropical%20radio%20station%20logo%2C%20palm%20tree%20silhouette%2C%20energetic%20yellow%20and%20green%20colors%2C%20clean%20white%20background%2C%20caribbean%20vibe%20brand&width=120&height=120&seq=global-avatar-14&orientation=squarish' },
    target: { name: 'Concurso: La Mejor Foto Playera', type: 'Concurso', link: '/competencias' },
    excerpt: 'Tropicana lanza concurso La Mejor Foto Playera: sube tu mejor foto de playa y gana un fin de semana todo pagado.',
    commentsCount: 234,
    reactionsCount: 3456,
  },
];

// ─── Stats ───
export const globalActivityStats = {
  totalHoy: 386,
  totalSemana: 2847,
  totalMes: 12340,
  ahoraActivos: 47,
  ahoraComentando: 12,
  ahoraSubiendo: 8,
  ahoraCompitiendo: 5,
  ahoraEventos: 9,
  ahoraNuevosClubes: 3,
  ahoraNuevasRadios: 2,
  ahoraGanadores: 8,
  picoHorario: '13:00 - 15:00',
  diaMasActivo: 'Viernes',
  promedioPorHora: 32,
  totalEntidades: {
    radios: 1438,
    programas: 3210,
    locutores: 4782,
    clubes: 891,
    eventos: 634,
  },
};

// ─── Reglas ───
export const activityRules = [
  {
    id: 1,
    title: 'Siempre mostrar actividad reciente real',
    description: 'El feed global muestra exclusivamente actividad orgánica de las últimas 48 horas. No hay contenido curado, patrocinado ni artificial. Lo que ves es lo que está pasando ahora mismo en RFW.',
    icon: 'ri-eye-line',
    color: 'emerald',
  },
  {
    id: 2,
    title: 'Una actividad = una notificación',
    description: 'Cada acción en RFW (comentar, subir, ganar, crear) genera exactamente una entrada en el feed global. Sin duplicados. Sin spam.',
    icon: 'ri-notification-3-line',
    color: 'sky',
  },
  {
    id: 3,
    title: 'Transparencia total',
    description: 'El feed global es visible para todos los usuarios, logueados o no. Es la vidriera de RFW: cualquiera puede ver que la plataforma está viva.',
    icon: 'ri-shield-check-line',
    color: 'amber',
  },
];

// ─── Helpers ───
export function getActivitiesByFilter(filterId: string) {
  if (filterId === 'todo') return globalActivityEntries;
  return globalActivityEntries.filter((a) => a.filterId === filterId);
}

export function getActivitiesByType(typeId: string) {
  return globalActivityEntries.filter((a) => a.type === typeId);
}

export function getRecentActivities(hours: number = 24) {
  const cutoff = new Date(Date.now() - hours * 60 * 60 * 1000).toISOString();
  return globalActivityEntries.filter((a) => a.timestamp >= cutoff);
}

export function getActivityDistribution() {
  const distribution: Record<string, number> = {};
  globalActivityEntries.forEach((a) => {
    distribution[a.type] = (distribution[a.type] || 0) + 1;
  });
  return Object.entries(distribution).map(([type, count]) => ({
    type,
    config: activityTypeConfigs.find((c) => c.id === type),
    count,
  }));
}

export function getFilterDistribution() {
  const distribution: Record<string, number> = {};
  globalActivityEntries.forEach((a) => {
    distribution[a.filterId] = (distribution[a.filterId] || 0) + 1;
  });
  return Object.entries(distribution).map(([filterId, count]) => ({
    filterId,
    config: filterConfigs.find((c) => c.id === filterId),
    count,
  }));
}

export const mockGlobalActivityTimes = [
  { time: '06:00', count: 4 },
  { time: '07:00', count: 8 },
  { time: '08:00', count: 15 },
  { time: '09:00', count: 12 },
  { time: '10:00', count: 18 },
  { time: '11:00', count: 22 },
  { time: '12:00', count: 28 },
  { time: '13:00', count: 35 },
  { time: '14:00', count: 32 },
  { time: '15:00', count: 29 },
  { time: '16:00', count: 24 },
  { time: '17:00', count: 20 },
  { time: '18:00', count: 16 },
  { time: '19:00', count: 22 },
  { time: '20:00', count: 19 },
  { time: '21:00', count: 14 },
  { time: '22:00', count: 9 },
  { time: '23:00', count: 5 },
];